import { Modal, ListGroup, Spinner } from "react-bootstrap";

export default function ConfirmModal({
  show,
  onClose,
  onConfirm,
  values,
  selectedSizeInfo,
  loading,
}) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title>Баталгаажуулах</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ListGroup variant="flush">
          <ListGroup.Item>
            <div className="fs-5 fw-bold mb-1">Илгээмж ачих хаяг</div>
            <div className="text-muted">
              {values.pickupDistrictName}, {values.pickupAddress}
            </div>
            <div className="text-muted">{values.pickupPhone}</div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="fs-5 fw-bold mb-1">Хүргэх хаяг</div>
            <div className="text-muted">
              {values.dropDistrictName}, {values.dropAddress}
            </div>
            <div className="text-muted">{values.dropPhone}</div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="fs-5 fw-bold mb-1">Ачааны төрөл</div>
            <div className="text-muted fw-semibold">
              {selectedSizeInfo?.label || "—"}
            </div>
            <div className="text-muted">{selectedSizeInfo?.desc}</div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="fs-5 fw-bold mb-1">Хүргэлтийн төлбөр</div>
            <div className="text-muted">
              {selectedSizeInfo?.price
                ? `${selectedSizeInfo.price.toLocaleString()}₮`
                : "—"}
            </div>
          </ListGroup.Item>

          <ListGroup.Item>
            <div className="alert alert-info fs-6 m-0" role="alert">
              Сонгосон оврын хэмжээ, жин бодит ачаанаас зөрсөн тохиолдолд жолооч
              хүргэлтийг цуцлах эрхтэй болохыг анхаарна уу.
            </div>
          </ListGroup.Item>
        </ListGroup>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={onClose}
          disabled={loading}
        >
          Буцах
        </button>
        <button
          className="btn btn-danger"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Түр хүлээнэ үү...
            </>
          ) : (
            "Төлбөр төлөх"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
